class PepFallPromo extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.options = JSON.parse(this.querySelector('[data-pep-options]').textContent);
    this.messages = JSON.parse(this.querySelector('[data-pep-messages]').textContent);
    this.form = this.querySelector('form');
    this.variantInput = this.querySelector('[data-pep-variant]');
    this.button = this.querySelector('[data-pep-submit]');
    this.status = this.querySelector('[data-pep-status]');
    this.requestNumber = 0;
    this.addEventListener('change', event => {
      if (event.target.matches('[data-pep-color], [data-pep-shirt-size], [data-pep-pants-size], [data-pep-pack]')) this.update();
    });
    this.form.addEventListener('submit', event => {
      if (this.button.disabled || !this.variantInput.value) event.preventDefault();
    });
    this.applyState(JSON.parse(this.querySelector('[data-pep-state]').textContent));
    this.expiryTimer = setInterval(() => {
      if (this.wasPromo && Date.now() >= Date.parse(this.options.endsAt)) window.location.reload();
    }, 60000);
  }

  disconnectedCallback() {
    this.controller?.abort();
    clearInterval(this.expiryTimer);
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.options.currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
  }

  applyState(state) {
    this.wasPromo = state.promoActive;
    this.variantInput.value = state.id || '';
    this.button.disabled = !state.id || !state.available;
    this.button.textContent = state.available ? this.messages.add : this.messages.soldOut;
    this.querySelector('[data-pep-price]').textContent = this.formatMoney(state.promoPrice);
    this.querySelector('[data-pep-regular]').textContent = this.formatMoney(state.regularPrice);
    this.querySelector('[data-pep-regular]').hidden = !state.promoActive;
    this.querySelector('[data-pep-saving]').textContent = state.promoActive ? this.messages.save + ' ' + this.formatMoney(state.regularPrice - state.promoPrice) : this.messages.ended;
    this.querySelector('[data-pep-checkout-note]').hidden = !state.promoActive;
    this.querySelector('[data-pep-sale-end]').hidden = !state.promoActive;
    for (const card of this.querySelectorAll('[data-pep-pack-card]')) {
      const regular = Number(card.dataset.baseRegular) + state.sizeExtra;
      card.querySelector('[data-pep-pack-price]').textContent = this.formatMoney(state.promoActive ? regular - Number(card.dataset.saving) : regular);
      card.querySelector('[data-pep-pack-regular]').textContent = this.formatMoney(regular);
      card.querySelector('[data-pep-pack-regular]').hidden = !state.promoActive;
    }
    this.status.textContent = state.available ? '' : this.messages.soldOut;
    this.form.removeAttribute('aria-busy');
  }

  async update() {
    const color = this.querySelector('[data-pep-color]:checked').value;
    const shirtSize = this.querySelector('[data-pep-shirt-size]').value;
    const pantsSelect = this.querySelector('[data-pep-pants-size]');
    for (const option of pantsSelect.options) {
      option.disabled = color === 'Purple' && option.value === '3X';
    }
    if (pantsSelect.selectedOptions[0].disabled) pantsSelect.value = '2X';
    this.querySelector('[data-pep-purple-note]').hidden = color !== 'Purple';
    const pack = this.querySelector('[data-pep-pack]:checked').value;
    const shirtValue = this.options.shirt.find(option => option.name === `${color} / ${shirtSize}`);
    const pantsValue = this.options.pants.find(option => option.name === pantsSelect.value);
    const packValue = this.options.packs.find(option => option.name === pack);
    if (!shirtValue || !pantsValue || !packValue) {
      this.button.disabled = true;
      this.status.textContent = this.messages.unavailable;
      return;
    }
    this.button.disabled = true;
    this.button.textContent = this.messages.checking;
    this.status.textContent = this.messages.checking;
    this.form.setAttribute('aria-busy', 'true');
    this.controller?.abort();
    this.controller = new AbortController();
    const number = ++this.requestNumber;
    const url = new URL(this.dataset.productUrl, window.location.origin);
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    url.searchParams.set('section_id', this.dataset.sectionId);
    url.searchParams.set('option_values', [shirtValue.id, pantsValue.id, packValue.id].join(','));
    try {
      const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Unable to check the selected bundle');
      const documentResponse = new DOMParser().parseFromString(await response.text(), 'text/html');
      const stateElement = documentResponse.querySelector('pep-fall-promo [data-pep-state]');
      if (!stateElement) throw new Error('The bundle response was incomplete');
      const state = JSON.parse(stateElement.textContent);
      if (number !== this.requestNumber) return;
      this.applyState(state);
      if (state.id) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('variant', state.id);
        currentUrl.searchParams.delete('option_values');
        window.history.replaceState({}, '', currentUrl);
      }
    } catch (error) {
      if (error.name === 'AbortError' || number !== this.requestNumber) return;
      this.variantInput.value = '';
      this.button.disabled = true;
      this.button.textContent = this.messages.add;
      this.status.textContent = this.messages.error;
      this.form.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('pep-fall-promo')) customElements.define('pep-fall-promo', PepFallPromo);
